import React from "react";

const MandatoryLabel = ({
  label,
  required = false,
  className = "",
}) => {
  return (
    <span className={className}>
      <span
        title={
          required
            ? "This is a mandatory field"
            : ""
        }
        // style={{
        //   fontWeight: "500",
        // }}
      >
        {required && (
          <span
            // style={{
            //   background: "#ff6b6b",
            //   color: "white",
            //   padding: "2px 2px",
            //   borderRadius: "2px",
            //   fontSize: "11px",
            //   fontWeight: "bold",
            //   marginRight: "4px",
            //   display: "inline-block",
            // }}
          >
            {/* Mandatory */}
          </span>
        )}
        {label}
      </span>

      :
    </span>
  );
};

export default MandatoryLabel;